import { Vue, Component, Emit } from 'vue-property-decorator'
import FormLogin from '../../components/login/form-login/FormLogin.component.vue'
import { DataLogin } from '@/types'
import Axios from 'axios'

@Component({
  components: {
    FormLogin
  }
})
export default class LoginPageComponent extends Vue {
  snackbar: boolean = false
  snackbarMessage: string = ''

  onLogin (data:DataLogin) {
    Axios.post('/users/login', {
      data
    }).then(response => {
      sessionStorage.setItem('token', JSON.stringify(response.data))
      Axios.defaults.headers.common['Authorization'] = `${response.data.tokenType} ${response.data.accessToken}`
      this.$router.push('/dashboard/documents')
    }).catch(error => {
      this.snackbarMessage = error.response.data.message
      this.snackbar = true
    })
  }
}
